import script from "./MoqInputPopUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoqInputPopUp.vue?vue&type=script&lang=ts&setup=true"

import "./MoqInputPopUp.vue?vue&type=style&index=0&id=b7c60964&lang=scss"

const __exports__ = script;

export default __exports__